"use client";
import { useState } from "react";
import { QuoteIcon } from "@icons/svgs";
import testimage from "@images/testimonies.png";
import styles from "@styles/testimonies.module.css";
import Image from "next/image";

export function Testimonies() {
  const [state, setState] = useState(1);

  const handleNext = () => {
    if (state === 7) {
      setState(1);
    } else {
      setState((prv) => prv + 1);
    }
  };
  const handlePrv = () => {
    if (state === 1) {
      setState(7);
    } else {
      setState((prv) => prv - 1);
    }
  };

  return (
    <div id="testimonies" className={styles.testimonies_container}>
      <div className={styles.testimonies_inner}>
        <span>testimonials</span>
        <h2>
          Study Experience at Olive International College of Natural
          Medicine
        </h2>
        {state === 1 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                I thought we would be given recipes on how to make different
                products, but I was shocked. This is another university l did
                not even plan to enrol in. It requires a lot of hard work and
                dedication but it is flexible as well. My experience at OICNM
                has been mind-blowing, the lecturers are capable, and the
                courses are well-detailed. I can confidently say that no one
                would go through this school and not give great feedback. Thank
                you very kindly Dr. Olaking and the OICNM management.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>AMARACHI SHULAMMITE OKEKE</h3>
                {/* <span>South Yorkshire, United Kingdom</span> */}
              </div>
              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 2 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                OICNM provided me with opportunities to develop myself further
                and take learning beyond the classroom to real-life situations
                through wonderful projects, assignments, tests and examinations.
                It was a very challenging experience. During my learning at
                OICNM, I had a better understanding of nature and health than I
                had previously. Now, with God’s help, using Traditional Chinese
                Medicine and Natural Medicine, fertility would be resolved and
                health would be restored. Thank you OICNM! God Bless OICNM!
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>ZAINAB AJOKE OWOYEMI </h3>
                {/* <span>South Yorkshire, Nigeria</span> */}
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 3 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                My experience while studying at OICNM was an amazing one. It was
                a different experience from when I spent 4 years in the tertiary
                institution. Very tasking and intriguing, one couldn’t predict
                what to wake up to, every lesson day, it’s different from the
                read-and-pass methods employed in most schools. So dynamic and
                impactful. Thank God, in the end.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>HAJARAT MOTUNRAYO MUHAMMAD</h3>
                {/* <span>South Yorkshire, United Ekiti</span> */}
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 4 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                My experience at Olive International College of Natural Medicine
                (OICNM) and studying the NARIM Course has been eye opening,
                intriguing, and filled with a lot of suspense, making you want
                to discover and learn more. Being a student in OICNM is like
                being part of a family who supports, guides, and encourages you
                through every step of your learning journey. Although I have had
                to defer my course once again due to family, educational and
                work commitments. I can honestly and proudly say that I will be
                back to finish this course because it is worth every bit of
                sacrifice. NARIM Course is number one of its kind in Nigeria.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>ESTHER EBELEGHE</h3>
                <span>South Yorkshire, United Kingdom</span>
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 5 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                Studying at OICNM is as delightful as munching cookies with the
                satisfying pleasure that one could derive therefrom, even though
                it was such a thorough, rigorous and remarkable adventure. I was
                given all that is needed to understand and comprehend all about
                Natural medicine including its ethics and jurisprudence. To say
                the least, OICNM is one of the leading Naturopathic Medicine
                schools in Nigeria, it is the best even in my humble estimation.
                This is because of the stratified and rich curriculum with a
                blend of international standards we were taught with and the
                excellent course delivery approach. Not only that, every student
                is equipped with the right orientation for acquiring sound
                knowledge, experience and careful practice at OICNM. In
                addendum, studying at OICNM is one of the biggest grace I’ve
                received. I can’t really thank my instructors enough especially,
                Dr. Qaasim Olaking for their unwavering efforts in imparting
                their knowledge and experience to us.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>ADAM ADEYEMI ABIODUN </h3>
                {/* <span>South Yorkshire, United Kingdom</span> */}
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 6 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                My experience on the NARIM course has been mind-blowing. Never
                believed I had the capacity to learn and comprehend the much I
                have in a very short time. I have been taking professional
                courses but none is closely compared to this. The syllabus is
                very rich, I&#39;ll say the lecturers are well trained to
                deliver on this course considering the different background of
                students. Their mode of teaching gives room for flexibility,
                students are free to ask questions as much as possible, and
                their constant encouragement spurs one to remain steadfast. They
                are such an awesome team! Although the program requires a lot of
                dedication, personal discipline for self-study and research; the
                transformational knowledge gained is worth every bit of the
                &#39;stress&#39;. If I can go through the course as a Banker,
                (especially because of the flexibility granted from time to time
                by the OICNM Management) I believe any dedicated person with a
                keen interest to gain knowledge in Naturopathy will also excel
                in it.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>PERPETUAL ONYEACHO </h3>
                {/* <span>South Yorkshire, United Kingdom</span> */}
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
        {state === 7 && (
          <div className={styles.reviews_main}>
            <div className={styles.reviews_left}>
              <div className={styles.reviews_img_container}>
                <Image src={testimage} alt="image of a girl" />
              </div>
            </div>
            <div
              className={styles.reviews_right}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <QuoteIcon />
              <p>
                I&#39;ve always been feeling privileged to have come across and
                learned from OICNM, the only Naturopathic medicine college
                I&#39;ve seen in Nigeria after thorough research to be of
                international standard, in the curriculum, ways of passing
                knowledge, and flexibility. It gladdens my heart always that I
                learnt from the personalities of Teachers at this college,
                they&#39;re always in the habit of being benevolent. I strongly
                recommend that people enrol and study in this college,
                you&#39;ll never regret you did so! Thanks and long live The
                OICNM.
              </p>
              <QuoteIcon />
              <div className={styles.review_author}>
                <h3>ISA KEHINDE OSENI</h3>
                {/* <span>South Yorkshire, United Kingdom</span> */}
              </div>

              <div className={styles.review_button_flex}>
                <button onClick={handlePrv}>{"<"}</button>
                <button onClick={handleNext}>{">"}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
